module.exports = __webpack_public_path__ + "img/jiuci-product.e51c7c22.jpg";